<template>
    <v-app>
        <v-navigation-drawer
            style="box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.19);"
            app
            clipped
            light
            color="white"
            class="roma-drawer"
            :mini-variant="drawerState"
            :v-model="drawerState"
            :temporary="false"
            v-if="$route.name !== 'ErrorPage'"
        >
            <!-- options list -->
            <v-list nav rounded>
                <!-- items -->
                <v-list-item
                    link
                    v-for="(link, i) in options"
                    :key="i"
                    :to="{ name: link.to }"
                    exact-active-class="roma-active"
                    :class="link.customClasses"
                >
                    <v-list-item-action class="drawer-item">
                        <img :src="link.icon" alt class="default" />
                        <img :src="link.iconActive" class="active" alt />
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="roma-cabin-bold">{{
                            link.title
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- group -->
                <!-- <v-list-group
                    link
                    v-for="(link, i) in options"
                    :key="i"
                    :to="{ name: link.to }"
                    exact-active-class="roma-active"
                    :class="link.customClasses"
                >
                    <template v-slot:activator>
                        <v-list-item-action class="drawer-item">
                            <img :src="link.icon" alt class="default" />
                            <img :src="link.iconActive" class="active" alt />
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="roma-cabin-bold">{{
                                link.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item link>
                        <v-list-item-title>Titulo</v-list-item-title>
                    </v-list-item>
                </v-list-group> -->
            </v-list>
        </v-navigation-drawer>

        <!-- temporary drawer -->
        <v-navigation-drawer v-model="left" class="roma-drawer" fixed temporary>
            <v-row class="justify-space-around justify-sm-end">
                <v-col cols="auto" sm="auto">
                    <v-btn
                        color="white"
                        fab
                        class="close-btn mx-5 d-none d-sm-block"
                        @click="left = !left"
                        small=""
                    >
                        <img src="@/assets/images/close.svg" alt="" />
                    </v-btn>
                    <!-- avatar -->
                    <v-avatar
                        color="white"
                        size="53"
                        class="d-block d-sm-none mx-5"
                    >
                        <img
                            src="@/assets/images/avatar_default.png"
                            alt="John"
                        />
                    </v-avatar>
                </v-col>
                <v-col class="d-block d-sm-none">
                    <p class="font-weight-bold">Camilo Navas</p>
                    <p class="">4to Básico A</p>
                </v-col>
            </v-row>

            <!-- options list -->
            <v-list nav rounded>
                <!-- items -->
                <template v-for="(link, i) in options">
                    <v-list-item
                        link
                        v-if="link.showEvaluations"
                        :key="i"
                        :to="{ name: link.to }"
                        exact-active-class="roma-active"
                        :class="link.customClasses"                   
                    >
                        <v-list-item-action class="drawer-item" v-if="link.showEvaluations">
                            <img :src="link.icon" alt class="default" />
                            <img :src="link.iconActive" class="active" alt />
                        </v-list-item-action>
                        <v-list-item-content v-if="link.showEvaluations" >
                            <v-list-item-title class="roma-cabin-bold">{{
                                link.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-list>
        </v-navigation-drawer>
        <RomaHeader :dpDrawer="ToggleDrawer" :dpTemporary="toggleTemporary" />

        <v-main class="layout-main">
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
import RomaDrawer from "./RomaDrawer.vue";
import RomaHeader from "./RomaHeader.vue";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            drawerState: null,
            left: false,
            options: [
                {
                    title: "Mis clases",
                    icon: require("@/assets/icons/my_class_icon.svg"),
                    iconActive: require("@/assets/icons/online-course.svg"),
                    to: "Lesson",
                    customClasses: "",
                    showEvaluations: true
                },
                {
                    title: "Tareas por revisar",
                    icon: require("@/assets/icons/tasks-reviews-icon.svg"),
                    iconActive: require("@/assets/icons/tasks-reviews-icon.svg"),
                    to: "Tareas",
                    customClasses: "",
                    showEvaluations: true

                },
                // {
                //     title: "Progreso",
                //     icon: require("@/assets/icons/progress-icon.svg"),
                //     iconActive: require("@/assets/icons/progress-icon.svg"),
                //     to: "Progreso",
                //     customClasses: "d-xl-none"
                // },
                //  {
                //      title: "Evaluaciones",
                //      icon: require("@/assets/icons/my_class_icon.svg"),
                //      iconActive: require("@/assets/icons/online-course.svg"),
                //      to: "Evaluations",
                //      customClasses: "",
                //      showEvaluations: false
                //     //  !this.user.roles.includes('Profesor')
                //  }
            ]
        };
    },
    components: {
        RomaHeader
    },
    // computed:{
    //  ...mapGetters({
    //         user: "getUserData"
    //     }),
    // },
    methods: {
        ToggleDrawer() {
            this.drawerState = !this.drawerState;
        },
        toggleTemporary() {
            this.left = !this.left;
        },
        ...mapActions({
            actionToggleDrawer: "toggleDrawer"
        })
    },
    watch: {
        drawer(val) {
            this.actionToggleDrawer(val);
        }
    }
};
</script>
<style lang="scss"></style>
